export const IMG_KPO = '/images/logo-kpo.png';
export const IMG_ORGANIZER = '/images/logo-organizator.png';

export const COMPETITION_PAGE_BG =
  'linear-gradient(160deg, #d0eefa 0%, #8ed9f5 35%, #4cc5f0 65%, #1aaedd 100%)';

export const KPO_DESCRIPTION =
  'Przedsięwzięcie pn. „Utworzenie i wsparcie funkcjonowania Branżowego Centrum Umiejętności dla branży ' +
  'spożywczej w dziedzinie Przetwórstwo mleczarskie w Zespole Szkół Zawodowych w Wysokiem Mazowieckiem" ' +
  'w ramach umowy nr KPO/24/1/BCU/U/0012 finansowane ze środków Instrumentu na rzecz Odbudowy i Zwiększenia ' +
  'Odporności, tj. Krajowy Plan Odbudowy i Zwiększenia Odporności (KPO)';
